import aimanaLogo from "@/assets/aimana-logo.png.asset.json";

const SisterProjectsStrip = () => {
  return (
    <section className="bg-cream py-20 md:py-28 border-t hairline">
      <div className="container mx-auto px-6 max-w-5xl text-center">
        <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-terracotta block mb-4">
          Taip pat rekomenduojame
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-ink mb-12 md:mb-16">
          Mūsų draugai
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-x-16 gap-y-10 md:gap-x-24">
          <a
            href="https://www.meditacijos.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Meditacijos"
            className="inline-flex items-center transition-opacity hover:opacity-70"
          >
            <span className="text-3xl md:text-4xl font-extrabold tracking-tight text-ink leading-none">
              meditacijos<span className="text-terracotta">.</span>
            </span>
          </a>
          <a
            href="https://www.aimana.lt"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Aimana"
            className="inline-flex items-center transition-opacity hover:opacity-70"
          >
            <img
              src={aimanaLogo.url}
              alt="Aimana"
              className="h-12 md:h-14 w-auto object-contain"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SisterProjectsStrip;
